/**
 * BillingAgreementService
 * Service for BillingAgreement entity operations
 * Route: api/billing-agreement
 * Controller: BillingAgreementController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * BillingAgreementService
 * Handles billing agreement CRUD operations
 * Maps to /api/billing-agreement endpoint
 */
export class BillingAgreementService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BillingAgreementService.DEFAULT_SERVICE_PATH,
            basePath: BillingAgreementService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Override getById to support GUID
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Billing agreement with ID ${id} not found`);
        }
        return response.data;
    }
    getByIdRaw(id) {
        const url = this.buildUrl(id);
        return this.http.get(url);
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate billing agreement cache
     * POST /api/billing-agreement/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate billing agreement cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
BillingAgreementService.DEFAULT_SERVICE_PATH = 'payments';
BillingAgreementService.BASE_PATH = 'api/billing-agreement';
//# sourceMappingURL=BillingAgreementService.js.map